<div class="favorite-card-wrapper">
  <div class="card-header">
    @if (icon) {
      <span class="fav-icon mb-icon {{ icon }}"></span>
    }
    @if (headerMeta.length) {
      <mb-meta-items
        [metaItems]="headerMeta"
        [showEmpty]="data.type === 'video' || data.type === 'audio'"
      ></mb-meta-items>
    }
  </div>

  @if (image || imageUrl) {
    <div class="card-image-wrapper">
      @if (data.type === 'video') {
        <mb-media class="absolute-positioned" [media]="data" [hoverplay]="true"></mb-media>
      }
      @if (image) {
        <mb-image class="absolute-positioned" [media]="image"></mb-image>
      }
      @if (imageUrl && data.type !== 'video') {
        <img class="static-image" [src]="imageUrl" [alt]="image?.caption || image?.title || 'Bookmarked image'" />
      }
      @if (data.type === pressKitType) {
        <span class="press-kit-flag copy-s">
          {{ 'PRESS_KIT' | translate }}
        </span>
      }
    </div>
  }

  <div class="card-content" [class.text-card-content]="!image && !imageUrl">
    <h2 class="card-title truncated-text h4" [innerHTML]="headline"></h2>
  </div>

  <div class="card-footer">
    @if (footerMeta && (footerMeta.type || footerMeta.size || footerMeta.time)) {
      <ul class="meta-items">
        @if (footerMeta.type) {
          <li class="meta-item">{{ footerMeta.type }}</li>
        }
        @if (footerMeta.size) {
          <li class="meta-item">{{ footerMeta.size | fileSize }}</li>
        }
        @if (footerMeta.time) {
          <li class="meta-item">{{ footerMeta.time }}</li>
        }
      </ul>
    }
    <mb-action-container [buttonItems]="actions" (actionClick)="actionClick($event)"></mb-action-container>
  </div>

  <div class="card-line-wrapper">
    <div class="card-line"></div>
  </div>
</div>
